define([
    "jquery",
    "underscore",
    "marionette",
    "views/common/mt4_members_select2_view",
    "views/common/chart_view"
], function($, _, Marionette, Mt4MembersSelect2View, ChartView){
    return Marionette.LayoutView.extend({
        el: '#content_layout',

        ui: {
            'filters': '.filter',
            'filterBtn': '#filter_btn',
            'select2Input': '.select2_input'
        },

        events: {
            'click @ui.filterBtn': 'redirectToMt4User'
        },

        regions: {
            'select2Mt4Members': '#select2_mt4_members',
            'chart': '#chart'
        },

        redirectToMt4User: function(){
            if(this.mt4MembersSelect2View.getValue() != null){
                window.location = "/report/traders_status_individual/"+this.mt4MembersSelect2View.getValue();
            }
        },

        initialize: function () {

            this.account_no = window.account_no || null;

            var that = this;
            this.bindUIElements();
            this.mt4MembersSelect2View = new Mt4MembersSelect2View({ select2El: this.ui.select2Input });

            this.chartView = new ChartView({
                pagination: {
                    navigation : false
                },
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                },
                ajax:{
                    url: '/rest_report/trader_status_individual_chart',
                    method: "POST",
                    parseData: function(data){
                        return {
                            series : [
                                {
                                    name: 'Symbol percentage',
                                    type: 'pie',
                                    radius : '70%',
                                    center: ['50%', '50%'],
                                    data: data.data,
                                    itemStyle: {
                                        emphasis: {
                                            shadowBlur: 10,
                                            shadowOffsetX: 0,
                                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                                        }
                                    }
                                }
                            ]
                        };
                    },
                    prepareData: function(){
                        var data = [];
                        data['account_no'] = that.account_no;

                        return data;
                    }
                },

            });
            this.showChildView('chart', this.chartView);

        }
    });
});
